import { useParams, Link } from "react-router-dom";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { SEO } from "@/components/SEO";
import { IMG } from "@/lib/images";
import { useLang } from "@/i18n/LanguageContext";
import { useSiteConfig } from "@/context/SiteConfigContext";
import { getLegalDoc, LEGAL_ORDER, LEGAL_UI } from "@/lib/legal";

export default function Legal() {
  const { type } = useParams();
  const { lang } = useLang();
  const { config } = useSiteConfig();
  const key = ["mentions", "cgv", "confidentialite", "cookies"].includes(type) ? type : "mentions";
  const doc = getLegalDoc(key, lang, config);
  const order = LEGAL_ORDER[lang] || LEGAL_ORDER.fr;
  const title = (order.find((o) => o.type === key) || order[0]).label;
  const ui = LEGAL_UI[lang] || LEGAL_UI.fr;

  return (
    <div data-testid="legal-page">
      <SEO title={doc.seoTitle} description={doc.seoDesc} path={`/legal/${key}`} lang={lang} image={IMG.philosophy} />
      <PageHeader eyebrow="O'Lime Design" lines={[title]} title={title} image={IMG.philosophy} />

      <section className="py-20 lg:py-28 bg-olime-bg">
        <div className="container-olime grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Side nav between legal pages */}
          <aside className="lg:col-span-3">
            <nav aria-label="Documents légaux" className="lg:sticky lg:top-28 space-y-3">
              {order.map((o) => (
                <Link
                  key={o.type}
                  to={`/legal/${o.type}`}
                  data-testid={`legal-nav-${o.type}`}
                  className={`block text-sm transition-colors duration-300 ${o.type === key ? "text-olime-ink font-medium" : "text-olime-muted hover:text-olime-ink"}`}
                >
                  {o.label}
                </Link>
              ))}
            </nav>
          </aside>

          <div className="lg:col-span-9 max-w-3xl">
            <p className="text-xs uppercase tracking-[0.2em] text-olime-stone mb-10">{ui.updated} — {doc.updated}</p>
            <div className="space-y-12">
              {doc.sections.map((s, i) => (
                <Reveal key={i} delay={Math.min(i * 0.04, 0.2)}>
                  <div data-testid={`legal-section-${i}`}>
                    <h2 className="font-serif text-2xl md:text-3xl tracking-tight text-olime-ink">{s.h}</h2>
                    <div className="mt-4 space-y-3 text-olime-muted leading-relaxed">
                      {s.p.map((par, j) => <p key={j}>{par}</p>)}
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
